import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IIncidents } from 'src/app/models/incident';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import { Visitor } from 'src/app/models/visitor';
import { Actions, ofType } from '@ngrx/effects';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/app/environments/environments';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
@Component({
  selector: 'app-view-container',
  templateUrl: './view-container.component.html',
  styleUrl: './view-container.component.scss',
})
export class ViewContainerComponent implements OnInit {
  screenSize: ScreenType;
  ScreenType = ScreenType;
  id: string = null;
  linkType: 'visitor' | 'incident';
  scrollToId: string = null;
  scrollTo: 'comments' | 'evidence';
  incidentDetails: IIncidents;
  visitorDetails: Visitor;
  isShowIncidentSection = false;
  isShowVisitorSection = false;
  isDataReady = false;

  destroyed$: Subject<any> = new Subject<any>();
  dashboardState$: Observable<IDashboardState>;
  dashboardData: IDashboardState;
  isNotValid = false;
  baseServerURL = environment.apiUrl;
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private _screenSize: AumyeResponsiveScreenService,
    private store: Store<IAumyeState>,
    private httpclient: HttpClient,
    private actions$: Actions,
    private dialog: MatDialog,
    private encryptionService: EncryptionService
  ) {
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.dashboardState$ = this.store.select('aumyeDashboardState');
    this.dashboardState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.dashboardData = data;
    });
  }
  orgId: string = null;
  ngOnInit(): void {
    const loggedUser = this.encryptionService.getCurrentUser();

    this.orgId = loggedUser.organizationID;
    this.route.queryParams.subscribe((params) => {
      this.linkType = params['linkType'];
      this.id = params['id'];
      this.scrollTo = params['scrollTo'];
      this.scrollToId = params['scrollId'];
      if (this.linkType && this.id) {
        if (this.linkType == 'incident') {
          this.onGetIncidentDetails(this.orgId);
        } else if (this.linkType == 'visitor') {
          this.onGetVisitorDetails(this.orgId);
        } else {
          this.isDataReady = true;
          this.isNotValid = true;
        }
      } else {
        this.isNotValid = true;
        this.isDataReady = true;
      }
    });
  }
  getClassForView() {
    switch (this.screenSize) {
      case ScreenType.Mobile:
        return 'view-component-container-mobile';
      case ScreenType.Tablet:
        return 'view-component-container-tablet';
      default:
        return 'view-component-container';
    }
  }
  isError = false;
  isOrgError = false;
  onGetIncidentDetails(orgId?: string) {
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let baseServerURL = this.baseServerURL + 'GetIncidentById';
    this.httpclient
      .get(`${baseServerURL}?id=${this.id}&timezone=${currentTimezone}`)
      .subscribe(
        (response: any) => {
          console.log(orgId, response, orgId == response.orgId);
          if (orgId && orgId == response.orgId) {
            this.isDataReady = true;
            this.incidentDetails = response;
            this.isShowIncidentSection = true;
            this.isError = false;
            this.dialog.closeAll();
            setTimeout(() => {
              this.scrollToComments();
            }, 1000);
          } else {
            console.log('Not a correct org ');
            this.dialog.closeAll();
            this.isDataReady = true;
            this.isError = true;
            this.isOrgError = true;
          }
        },
        (error) => {
          this.dialog.closeAll();
          this.isDataReady = true;
          this.isError = true;
          console.error('Error checking phone number', error);
        }
      );
  }
  onGetVisitorDetails(orgId: string) {
    let baseServerURL = this.baseServerURL + 'GetVisitorById';
    this.httpclient.get(`${baseServerURL}?id=${this.id}`).subscribe(
      (response: any) => {
        console.log(orgId, response.orgID, orgId == response.orgID);
        if (orgId && orgId == response.orgID) {
          this.isDataReady = true;
          this.visitorDetails = response;
          this.isShowVisitorSection = true;
          this.isError = false;
          this.dialog.closeAll();
          setTimeout(() => {
            this.scrollToComments();
          }, 1000);
        } else {
          console.log('Not a correct org ');
          this.dialog.closeAll();
          this.isDataReady = true;
          this.isError = true;
          this.isOrgError = true;
        }
      },
      (error) => {
        this.dialog.closeAll();
        this.isDataReady = true;
        this.isError = true;
        console.error('Error checking phone number', error);
      }
    );
  }
  selectedCommentId: string = null;
  scrollToComments() {
    if (this.scrollTo && this.scrollToId) {
      this.selectedCommentId = this.scrollToId;
    }
  }
  onCloseDetail() {
    this.store.dispatch(new fromDashboardActions.InitDashboard({}));
  }

  onSnoozeIncident(val: any) {
    let previousDetails = this.incidentDetails;
    // if (!previousDetails) {
    //   previousDetails = this.dashboardData.complaintsTickets.find(
    //     (x) => x.complainId == val.incidentId.toLowerCase()
    //   )?.complainIncidentDetails;
    //   if (!previousDetails) {
    //     previousDetails = this.dashboardData.requestsTickets.find(
    //       (x) => x.complainId == val.incidentId.toLowerCase()
    //     )?.complainIncidentDetails;
    //     if (!previousDetails) {
    //       previousDetails = this.dashboardData.claimTickets.find(
    //         (x) => x.complainId == val.incidentId.toLowerCase()
    //       ).complainIncidentDetails;
    //     }
    //   }
    // }
    val['previousStatus'] = previousDetails.incidentStatus;
    val['previousAssigned'] = previousDetails.assignedTo;
    val['previousIncidentName'] = previousDetails.incidentName;
    val['previousCreatedBy'] = previousDetails.eventCreatedBy;
    val['previousIncidentType'] = previousDetails.incidentType;
    val['previousSourceAsset'] = previousDetails.sourceAsset;
    val['previousIncidentLocation'] = previousDetails.incidentLocation;
    val['previousIncidentDescription'] = previousDetails.incidentDescription;
    val['previousIncidentCriticality'] = previousDetails.incidentCriticality;
    this.store.dispatch(new fromDashboardActions.SnoozeIncident(val));
    this.onListenToSuccessAction();
  }
  onListenToSuccessAction() {
    const OrgId = this.orgId;
    this.actions$
      .pipe(
        ofType(
          fromDashboardActions.DashboardActionTypes.SNOOZE_INCIDENT_SUCCESS
        ),
        take(1) // Take the first instance of the action being dispatched
      )
      .subscribe((action) => {
        console.log('SnoozeIncidentSuccess action received!');
        this.onGetIncidentDetails(OrgId);
      });
  }
  onListenToCommentsSuccessAction() {
    const OrgId = this.orgId;
    this.actions$
      .pipe(
        ofType(
          fromDashboardActions.DashboardActionTypes.POST_USER_COMMENT_SUCCESS
        ),
        take(1) // Take the first instance of the action being dispatched
      )
      .subscribe((action) => {
        console.log('SnoozeIncidentSuccess action received!');
        this.onGetIncidentDetails(OrgId);
      });
  }
  isShowIncidentTimline = false;
  isFaceIncident = false;
  isANPRIncident = false;
  isShowVisitorTimline = false;
  onShowTimeline(val: any) {
    this.isShowIncidentTimline = val;
    this.isFaceIncident = this.incidentDetails.isFaceMatch == 1;
    this.isANPRIncident = this.incidentDetails.isANPR == 1;
  }
  onShowVisitorTimeline(val: any) {
    this.isShowVisitorTimline = val;
  }
  onPostIncidentComment(val: any) {
    this.store.dispatch(new fromDashboardActions.PostUserComment(val));
    this.onListenToCommentsSuccessAction();
  }
  onUpdateVisitorDetails(val: any) {
    val['NoStatus'] = true;
    this.store.dispatch(new fromDashboardActions.UpdateVisitorDetails(val));
    if (val.isActive == '0') {
      setTimeout(() => {
        this.onCloseDetail();
      }, 2000);
    }
  }
  onListenToVisitorAction() {
    const OrgId = this.orgId;
    this.actions$
      .pipe(
        ofType(
          fromDashboardActions.DashboardActionTypes
            .UPDATE_VISITOR_DETAILS_SUCCESS
        ),
        take(1) // Take the first instance of the action being dispatched
      )
      .subscribe((action) => {
        console.log('UpdateVisitorSuccess action received!');
        this.onGetVisitorDetails(OrgId);
      });
  }
  onListenToVisitorCommentsAction() {
    const OrgId = this.orgId;
    this.actions$
      .pipe(
        ofType(
          fromDashboardActions.DashboardActionTypes.POST_USER_COMMENT_SUCCESS
        ),
        take(1) // Take the first instance of the action being dispatched
      )
      .subscribe((action) => {
        console.log('UpdateVisitorSuccess action received!');
        this.onGetVisitorDetails(OrgId);
      });
  }
  onPostVisitorComment(val: any) {
    this.store.dispatch(new fromDashboardActions.PostUserComment(val));
    this.onListenToVisitorCommentsAction();
  }
}
